import { SearchClientManager } from "../../../ls2pac/ClientManagers/SearchClientManager";
import { LS2KIDS_CONSTANTS } from "../../constants";

/**
 * tlc.ls2kids.ClientManager.Searching.SeriesSearchClientManager
 */
export class KidsSeriesSearchClientManager extends SearchClientManager {
	constructor(options) {
		super(options);
	}
	onBeforeFireSearch(event) {
		//	if( event.seriesId ) {
		//		this.seriesId = event.seriesId;
		//	}
		if (event.seriesId) {
			this.seriesId = event.seriesId;
		}

		if (!event.fromHistory) {
			this.resetPageCache(true);
		}

		super.onBeforeFireSearch(event);
	}
	getSearchParams(event) {
		return {
			seriesId: this.seriesId,
			startIndex: this.currentPage * this.pageSize,
			hitsPerPage: this.pageSize,
			branchFilters: this.getBranchFilters(),
			targetAudience: LS2KIDS_CONSTANTS.targetAudience
		};
	}
	getSearchCount() { }
}




